require('./style.less');

var ThumbView = require('../pgThumb');


module.exports = ThumbView.extend({

    template: require('./unrenderableThumb.hbs'),

    NON_LOADING: 1,

    APPLY_TRANSFORM: 0

});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/thumbnail/unrenderableThumb/unrenderableThumb.js
 ** module id = 564
 ** module chunks = 0
 **/